import { Contract } from "@ethersproject/contracts";
import { AlchemyProvider } from "@ethersproject/providers";

export const ethProvider = new AlchemyProvider(
  undefined,
  process.env.NEXT_PUBLIC_ALCHEMY_KEY
);

export const polygonProvider = new AlchemyProvider(
  "matic",
  process.env.NEXT_PUBLIC_ALCHEMY_POLYGON_KEY
);

export const getProvider = (isPolygonChainActive: boolean) =>
  isPolygonChainActive ? polygonProvider : ethProvider;

export const getERC20TokenClient = (
  tokenAddress: string,
  abi: any,
  isPolygonChainActive: boolean
) => new Contract(tokenAddress, abi, getProvider(isPolygonChainActive));

export const getXTokenClient = (
  xTokenAddress: string,
  abi: any,
  isPolygonChainActive: boolean
) => new Contract(xTokenAddress, abi, getProvider(isPolygonChainActive));

export const getERC20StakeManagerClient = (
  cAddress: string,
  abi: any,
  isPolygonChainActive: boolean
) => new Contract(cAddress, abi, getProvider(isPolygonChainActive));

export const getERCTokenClientWithSigner = (
  tokenAddress: string,
  abi: any,
  signer: any
) => new Contract(tokenAddress, abi, signer);

export const getXTokenClientWithSigner = (
  xTokenAddress: string,
  abi: any,
  signer: any
) => new Contract(xTokenAddress, abi, signer);
